import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";

// Subscription payments, served by profile-erp (/subscriptionPayment).
class SubscriptionPaymentService {
  // client: declare a payment { amount, mode, reference, proofFileUrl }
  submit(payment) {
    return api.post("/subscriptionPayment/submit/" + currentUserId(), payment);
  }
  // client: payments of the connected user's company, newest first
  mine() {
    return api.get("/subscriptionPayment/mine/" + currentUserId());
  }
  cancel(idPayment) {
    return api.put("/subscriptionPayment/cancel/" + currentUserId() + "/" + idPayment);
  }
  // super admin
  pending() {
    return api.get("/subscriptionPayment/pending/" + currentUserId());
  }
  pendingCount() {
    return api.get("/subscriptionPayment/pendingCount/" + currentUserId());
  }
  validate(idPayment) {
    return api.put("/subscriptionPayment/validate/" + currentUserId() + "/" + idPayment);
  }
  refuse(idPayment, reason) {
    return api.put("/subscriptionPayment/refuse/" + currentUserId() + "/" + idPayment, { reason });
  }
}

export default new SubscriptionPaymentService();
